module.exports = __webpack_public_path__ + "img/settings.9f33d9cc.png";